import React, { useState } from "react";
import "./BillNumberForm.scss";
import { useTranslation } from "react-i18next";
import { Field, Form, Formik } from "formik";
import { initialValuesBillNumber, schemaBillNumber } from "./schemaValidation";
import { hideLoading, showLoading } from "../../../reducers/app";
import { useDispatch } from "react-redux";
import { client } from "../../../App";
import { GET_INVOICE_INFO } from "../../../helpers/queries";
import { standardizeGraphQLError } from "../../../helpers/helpers";

const BillNumberForm = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  let formik;

  const [errorMessage, setErrorMessage] = useState("autolettura.erro.bill");
  const [hasError, setHasError] = useState(false);
  const [initialValues] = useState(initialValuesBillNumber);

  const handleBillNumberForm = (values, { setErrors }, t) => {
    handleBillNumber(values.codIdBolletta)
      .then((data) => {
        props.setInvoiceInfoData(data.data.invoiceInfo);
        setHasError(false);
        dispatch(hideLoading());
      })
      .catch((err) => {
        const e = standardizeGraphQLError(err);
        console.log(e);

        if (e) {
          if (Array.isArray(e)) {
            if ("reading" in e[0]) {
              setErrorMessage(e[0].reading.props.i18nKey);
            }
          } else if (typeof e === "object") {
            if ("type" in e) {
              setErrorMessage(e.error);
            }
          } else {
            setErrorMessage("common.serverError");
          }
          setHasError(true);
        }
        dispatch(hideLoading());
      });
  };

  const handleBillNumber = async (codIdBolletta) => {
    try {
      await dispatch(showLoading());
      return await getBillDataQuery(codIdBolletta);
    } catch (error) {
      throw error;
    }
  };
  const getBillDataQuery = (codIdBolletta) =>
    client(true).query({
      query: GET_INVOICE_INFO,
      variables: { codIdBolletta },
    });

  const resetForms = () => {
    props.setInvoiceInfoData(undefined);
    formik.resetForm();
  };

  return (
    <div
      className="BillNumberForm"
      data-testid="BillNumberForm"
    >
      <Formik
        innerRef={(p) => (formik = p)}
        initialValues={initialValues}
        enableReinitialize={true}
        validationSchema={schemaBillNumber}
        onSubmit={(value, props) => handleBillNumberForm(value, props, t)}
      >
        {({ errors, touched, submitCount }) => (
          <Form id={"amministratori-condominio-form"} noValidate>
            <div className="form-group d-flex flex-column">
              <label
                htmlFor={"codIdBolletta"}
                className="paragraph-small-fs9"
              >
                {t("casses.amministratori_di_condominio.bolleta.label")}
              </label>

              <Field
                className={
                  (errors.codIdBolletta || hasError) &&
                  touched.codIdBolletta &&
                  submitCount > 0
                    ? "form-control is-invalid"
                    : "form-control"
                }
                type="text"
                key="codIdBolletta"
                id="codIdBolletta"
                name="codIdBolletta"
                required={true}
                aria-describedby={hasError ? "codIdBolletta-error" : null}
                placeholder={t(
                  "tool.amministratori_di_condominio.bollette.placeholder"
                )}
              />
              {errors.codIdBolletta &&
              touched.codIdBolletta &&
              submitCount > 0 ? (
                <p
                  className="form-error-text paragraph-small-form"
                  role="alert"
                  id={"codIdBolletta-error"}
                >
                  {errors.codIdBolletta}
                </p>
              ) : null}

              {hasError &&
              !errors.codIdBolletta &&
              touched.codIdBolletta &&
              submitCount > 0 ? (
                <p
                  className="form-error-text paragraph-small-form"
                  role="alert"
                  id={"codIdBolletta-error"}
                >
                  {t(errorMessage)}
                </p>
              ) : null}
            </div>
            {!props.invoiceData && (
            <div className="d-flex justify-content-end btn-content">
              <button className={"btn btn-primary"} type="submit">
                {t(
                  "casses.amministratori_di_condominio.bollette.button.calcola.label"
                )}
              </button>
            </div>
            )}
          </Form>
        )}
      </Formik>
      {props.invoiceData && (
        <div className={"reset-container d-flex justify-content-end btn-content-error"}>
          <button
            className={"btn btn-primary"}
            type="reset"
            onClick={resetForms}
          >
            {t("button.reset")}
          </button>
        </div>
      )}
    </div>
  );
};

BillNumberForm.propTypes = {};

export default BillNumberForm;
